class FixedFilter {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.initAnimation();
      this.event();
    }
  }

  initAnimation() {
    // GSAPアニメーションの初期設定
    this.gsapTimeline = gsap.timeline({ paused: true });
    this.gsapTimeline.to("." + this.el, { duration: 0.5, bottom: "1rem" });
  }

  event() {
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= lastScroll) {
        // 上にスクロールしている場合、またはスクロールが停止している場合
        this.gsapTimeline.play();
      } else {
        // 下にスクロールしている場合
        this.gsapTimeline.reverse();
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll; // スクロール位置を更新

      // スクロールが停止したことを検出
      clearTimeout(window.scrollFinished);
      window.scrollFinished = setTimeout(() => {
        this.gsapTimeline.play();
      }, 100);
    });
  }
}